/* global Alpine, fetchConfig, */
import {
  getOGCustomer,
  getOGUpcomingOrders as ogGetOgUpcomingOrders,
  sortOGOrders as ogSortOGOrders,
  getOGOrder,
  addItemToNextBox as ogAddItemToNextBox,
  createFromItem as ogCreateFromItem,
  getOGSubscriptions
} from '../subscription-modal/ordergroove-api-helper';

// Track the last variant that was added to prevent duplicate events
window.dsc = window.dsc || {};
window.dsc.lastAddedVariantQuickview = null;

export const quickviewSwitcher = () => ({
  currentView: 'default',
  isOpen: false,
  isLoading: false,
  productHandle: null,
  productData: { options: [], variants: [] },
  productImage: null,
  productCollections: null,
  selectedVariant: { id: null, available: false, options: [], price: 0, compare_at_price: 0 },
  variantPriceDisplay: null,
  variantComparePriceDisplay: null,
  discountSummaryHTML: null,
  oneTimeDiscountHTML: null,
  oneTimePrice: null,
  showComparePrice: false,
  quantity: 1,
  purchaseOption: 'ship-now',
  sellingPlanId: null,
  selling_plan_groups: [],
  isSubscriber: false,
  customerId: null,
  ogInitialized: false,
  ordergrooveLoading: true,
  numberOfSellingPlans: 0,
  percentageOff: null,
  formElement: null,
  boundHandleFormSubmit: null,
  upcomingOrders: [],
  isInNextBox: false,
  frequencySortOrder: null,
  frequencyDefault: null,
  isInSubscription: false,
  addToCartButtonText: window.dsc.addToCartText,
  productsInNextOrderCache: null,
  nextOrderDate: null,
  nextBoxShipsText: '',
  inYourNextBoxText: '',
  submitButtonStateDisabled: false,
  isAvailable: true,
  isAccountOrOrderPage: window.location.pathname.startsWith('/account') || window.location.pathname.startsWith('/orders'),
  currency: window.Shopify.currency.active,
  locale: window.Shopify.locale + '-' + window.Shopify.country,
  defaultPurchaseOptionSubscribers: null,
  defaultPurchaseOption: null,
  requiresSellingPlan: false,

  init() {
    this.setupEventListeners();

    this.$watch('selectedVariant', (variant) => {
      if (variant && variant.id) {
        this.updateVariantData(variant);
      }
    });

    this.$watch('sellingPlanId', () => {
      if (this.purchaseOption === 'subscribe') {
        this.setPurchaseOption('subscribe');
      }
    });
  },

  setupEventListeners() {

      document.addEventListener('rebuy:smartcart.ready', () => {
        if (window.Rebuy && window.Rebuy.SmartCart && this.$el.getAttribute('data-allow-atc-flyout-cart') === 'false') {
          window.Rebuy.SmartCart.skip_open = true;
        }
      });

    window.addEventListener('quickview:open', async (event) => {
      this.isOpen = true;
      this.isLoading = true;
      this.productHandle = event.detail.productHandle;
      this.productCollections = event.detail.productCollections || null;
      this.defaultPurchaseOptionSubscribers = event.detail.defaultPurchaseOptionSubscribers;
      this.defaultPurchaseOption = event.detail.defaultPurchaseOption;
      this.requiresSellingPlan = event.detail.requiresSellingPlan || false;
      this.customerId = event.detail.customerId || null;
      this.isSubscriber = event.detail.isSubscriber || false;
      this.discountSummaryHTML = event.detail.discountSummary ? event.detail.discountSummary.innerHTML : null;
      this.oneTimeDiscountHTML = event.detail.oneTimeDiscount ? event.detail.oneTimeDiscount.innerHTML : null;
      this.frequencySortOrder = event.detail.frequencySortOrder || null;
      this.frequencyDefault = Array.isArray(this.frequencySortOrder) && this.frequencySortOrder.length > 0
        ? String(this.frequencySortOrder[0]).trim()
        : String(window.dsc?.ogDefaultFrequency || 1);
      if (!this.customerId) {
        try {
          const response = await fetch('/account.js');
          const contentType = response.headers.get('content-type');
          if (response.ok && contentType && contentType.includes('application/json')) {
            const accountData = await response.json();
            this.customerId = accountData.id || null;
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error fetching account data:', error);
        }
      }

      await this.fetchProductData();
      this.isLoading = false;

      this.$nextTick(() => {
        this.formElement = this.$el.querySelector('.quickview-add-to-cart-form');
        if (this.formElement) {
          this.formElement.addEventListener('submit', this.boundHandleFormSubmit);
        }
        this.ordergrooveLoading = true;
      });
      this.boundHandleEscapeKey = this.handleEscapeKey.bind(this);
      this.boundHandleFormSubmit = this.handleFormSubmit.bind(this);
      document.addEventListener('keydown', this.boundHandleEscapeKey);
    });

    window.addEventListener('quickview:close', () => {
      this.isOpen = false;
      this.productHandle = null;
      this.productData = { options: [], variants: [] };
      this.productCollections = null;
      this.ordergrooveLoading = true;
      this.ogInitialized = false;
    });

    this.$watch('isOpen', (value) => {
      if (value) {
        document.documentElement.classList.add('quickview-open');
        // Lock body scroll (iOS-safe)
        this.__scrollY = window.scrollY || document.documentElement.scrollTop || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.__scrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overscrollBehavior = 'none';
        document.documentElement.style.overscrollBehavior = 'none';
      } else {
        document.documentElement.classList.remove('quickview-open');
        if (this.boundHandleEscapeKey) {
          document.removeEventListener('keydown', this.boundHandleEscapeKey);
        }
        if (this.formElement && this.boundHandleFormSubmit) {
          this.formElement.removeEventListener('submit', this.boundHandleFormSubmit);
        }
        // Unlock body scroll and restore position
        const computedTop = parseInt(document.body.style.top || '0', 10);
        const restoreY = typeof this.__scrollY === 'number' ? this.__scrollY : (isNaN(computedTop) ? 0 : -computedTop);
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overscrollBehavior = '';
        document.documentElement.style.overscrollBehavior = '';
        const isIOS = /iP(hone|ad|od)/.test(window.navigator.userAgent);
        const restore = () => {
          // double RAF helps ensure styles/layout have settled before restoring
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              window.scrollTo(0, restoreY || 0);
            });
          });
        };
        // If iOS, wait for the transition to finish (~500ms in template)
        if (isIOS) {
          setTimeout(restore, 520);
        } else {
          restore();
        }
      }
    });
  },

  handleEscapeKey: function (event) {
    if (event.key === 'Escape') {
      this.clickClose();
    }
  },

  switchView(viewName) {
    if (this.currentView !== viewName) {
      this.currentView = viewName;
    }
  },

  handleViewChange(newView) {
    this.$dispatch('quickview-switched', {
      view: newView,
      timestamp: Date.now(),
    });
  },

  resetState() {
    this.quantity = 1;
    this.selling_plan_groups = [];
    this.selling_plan_allocations = null;
    this.numberOfSellingPlans = 0;
    this.currentView = 'default';
    this.productData = { options: [], variants: [] };
    this.productCollections = null;
    this.selectedVariant = { id: null, available: false, options: [], price: 0, compare_at_price: 0 };
    this.variantPriceDisplay = null;
    this.variantComparePriceDisplay = null;
    this.discountSummaryHTML = null;
    this.oneTimeDiscountHTML = null;
    this.showComparePrice = false;
    this.percentageOff = null;
    this.ogInitialized = false;
    this.ordergrooveLoading = true;
    this.purchaseOption = 'ship-now';
    this.sellingPlanId = null;
    this.isInNextBox = false;
    this.isInSubscription = false;
    this.addToCartButtonText = window.dsc.addToCartText || 'Add to Cart';
    this.submitButtonStateDisabled = false;
    this.isAvailable = true;
    this.isAccountOrOrderPage = window.location.pathname.startsWith('/account') || window.location.pathname.startsWith('/orders');
  },

  closeQuickview() {
    this.isOpen = false;
    this.resetState();
    this.$dispatch('quickview-closed');
  },

  clickClose() {
    document.querySelectorAll('[x-data="quickviewSwitcher"]').forEach((el) => {
      const component = Alpine.$data(el);
      if (component && typeof component.closeQuickview === 'function') {
        component.closeQuickview();
      }
    });
    this.closeQuickview();
  },

  openQuickviewWithProduct(payload) {
    this.isLoading = true;
    this.formElement = this.$el.closest('form');
    this.productData = payload.product;
    this.productImage = payload.productImage;
    this.selectedVariant = payload.product.variants ? payload.product.variants[0] : { id: null, available: false, options: [], price: 0, compare_at_price: 0 };
    this.customerId = payload.customerId || null;
    this.isSubscriber = payload.isSubscriber || false;
    this.selling_plan_groups = this.productData.selling_plan_groups;
    this.sellingPlanId = this.resolveDefaultSellingPlanId(this.productData.selling_plan_groups);
    this.numberOfSellingPlans = payload.numberOfSellingPlans;
    this.addToCartButtonText = window.dsc.addToCartText;
    this.getVariantPrice();
    this.getVariantComparePrice();
    this.isOpen = true;
    this.$nextTick(() => {
      this.initializeOrdergroove();
    });
  },

  selectVariant(variantId) {
    if (this.productData && this.productData.variants) {
      const variant = this.productData.variants.find((v) => v.id == variantId);
      if (variant) {
        this.selectedVariant = variant;
      }
    }
  },

  updateVariantData(variant) {
    if (!variant) return;
    this.isAvailable = variant.available;
    this.submitButtonStateDisabled = !variant.available;
    this.variantPriceDisplay = null;
    this.variantComparePriceDisplay = null;
    this.percentageOff = null;
    this.showComparePrice = false;
    this.isInNextBox = false;
    this.isInSubscription = false;
    this.getVariantPrice();
    this.getVariantComparePrice();
    this.updateOneTimePrice();
    this.$dispatch('variant-changed', {
      variant,
      productId: this.productData?.id,
    });
    this.$nextTick(() => {
      this.initializeOrdergroove();
    });
  },

  getProductImage(size = '140x140') {
    if (!this.productData?.featured_media?.src) return '';
    const baseUrl = this.productData.featured_media.src;
    const extension = baseUrl.split('.').pop();
    const urlWithoutExtension = baseUrl.replace(`.${extension}`, '');
    return `${urlWithoutExtension}_${size}.${extension}`;
  },

  getVariantPrice() {
    if (!this.selectedVariant?.price) return '';
    let price = this.selectedVariant.price / 100;
    /*
    if (this.oneTimePriceValue && this.oneTimePriceValue < price) {
      this.oneTimePrice = this.oneTimePrice;
    }
    */

    this.price = price;
    this.variantPriceDisplay = new Intl.NumberFormat(this.locale, {
      style: 'currency',
      currency: this.currency,
    }).format(price) || '';
  },

  updateOneTimePrice() {
    if (!this.selectedVariant?.id) {
      this.oneTimePrice = null;
      return;
    }
    const discountEstimateEl = document.querySelector(`.discount-estimate[data-variant-id="${this.selectedVariant.id}"]`);
    const priceContainer = discountEstimateEl?.querySelector('.price-container');
    if (priceContainer?.dataset?.oneTimePrice) {
      this.oneTimePrice = `$${priceContainer.dataset.oneTimePrice}`;
    } else {
      this.oneTimePrice = null;
    }
  },

  getVariantComparePrice() {
    if (!this.selectedVariant?.compare_at_price) return '';

    this.comparePrice = this.selectedVariant.compare_at_price / 100;
    if (this.comparePrice > this.price) {
      this.showComparePrice = true;
      let discount = this.comparePrice - this.price;
      this.percentageOff = Math.round((discount / this.comparePrice) * 100);
    }
    this.variantComparePriceDisplay = new Intl.NumberFormat(this.locale, {
      style: 'currency',
      currency: this.currency,
    }).format(this.comparePrice) || '';
  },

  isVariantAvailable(variantId) {
    if (!this.productData?.variants) return false;
    const variant = this.productData.variants.find((v) => v.id == variantId);
    this.isAvailable = variant ? variant.available : this.productData.available;
    return this.isAvailable;
  },

  isCurrentView(viewName) {
    return this.currentView === viewName;
  },


  async initializeOrdergroove() {
    if (!this.formElement) {
      this.ordergrooveLoading = false;
      return;
    }

    if (!this.selectedVariant || !this.productData) {
      this.ordergrooveLoading = false;
      return;
    }
    this.addToCartButtonText = window.dsc.addToCartText;
    if(!this.isAvailable) {
      this.submitButtonStateDisabled = true;
      this.addToCartButtonText = window.dsc.soldOutText;
    }

    this.ordergrooveLoading = true;

    try {
      await window.dsc?.ensureSubscriberHydrated?.();

      const [ogCustomer, ogUpcomingOrders] = await Promise.all([
        getOGCustomer(this.customerId),
        ogGetOgUpcomingOrders(this.customerId),
      ]);

      this.upcomingOrders = ogUpcomingOrders;

      if (ogUpcomingOrders && ogUpcomingOrders.results && ogUpcomingOrders.results.length) {
        ogSortOGOrders(ogUpcomingOrders.results);
      }

      this.isSubscriber = !!(ogCustomer && ogUpcomingOrders && ogUpcomingOrders.count > 0);

      if (this.isSubscriber && ogUpcomingOrders && ogUpcomingOrders.results.length > 0) {

        const nextOrderSummary = ogUpcomingOrders.results[0];

        if (this.productsInNextOrderCache) {
          this.isInNextBox = this.selectedVariant?.id && this.productsInNextOrderCache.some(
            (product) => product.id.toString() === this.selectedVariant.id.toString(),
          );
        }
        else {
          const nextOrder = await getOGOrder(nextOrderSummary.public_id);

          if (nextOrder && nextOrder.results) {
            const productIdsInNextOrder = [...new Set(nextOrder.results.map(item => item.product))];

            this.isInNextBox = this.selectedVariant?.id && productIdsInNextOrder.some(
              (productId) => productId.toString() === this.selectedVariant.id.toString()
            );

            if (ogUpcomingOrders?.results[0] && ogUpcomingOrders.results[0].place) {
              const date = new Date(ogUpcomingOrders.results[0].place);
              const options = { month: 'long', day: 'numeric' };
              this.nextOrderDate = new Intl.DateTimeFormat(this.locale, options).format(date);
              this.nextBoxShipsText = window.dsc.yourNextBoxShips + ` ${this.nextOrderDate}`;
              this.inYourNextBoxText = window.dsc.inYourNextBoxText + ` ${this.nextOrderDate}`;
            }
          }
        }
      } else {
        this.isInNextBox = false;
      }
    } catch (error) {
      this.isSubscriber = false; // Reset on error
    } finally {
      // Dispatch club benefits data for quickview UI (only for logged-in users)
      // Must fetch subscriptions to get accurate active subscription count
      if (this.customerId) {
        try {
          const subscriptions = await getOGSubscriptions(this.customerId);
          let activeSubscriptionsCount = 0;
        
          if (subscriptions && Array.isArray(subscriptions.results)) {
            const activeSubscriptions = subscriptions.results.filter(sub => sub.live === true);
            activeSubscriptionsCount = activeSubscriptions.length;
          }
        
          window.dsc = window.dsc || {};
          window.dsc.activeSubscriptionsCount = activeSubscriptionsCount;
          window.dsc.clubBenefitsLoaded = true;

          document.dispatchEvent(new CustomEvent('club-benefits-data-ready', {
            detail: {
              activeSubscriptionsCount,
              clubBenefitsSubActionTaken: window.dsc.clubBenefitsSubActionTaken ?? false,
            }
          }));
        } catch (error) {
          // Fallback if fetching subscriptions fails
          window.dsc = window.dsc || {};
          window.dsc.activeSubscriptionsCount = null;
          window.dsc.clubBenefitsLoaded = false;
        }
      }

      // Always finalize the UI state for all users (logged in or not)
      this.setDefaultPurchaseOption();
      this.ogInitialized = true;
      this.ordergrooveLoading = false;
    }
  },

  invalidateProductsInNextOrderCache() {
    this.productsInNextOrderCache = null;
    this.nextOrderDate = null;
    this.yourNextBoxShipsText = '';
    this.inYourNextBoxText = '';
  },

  setDefaultPurchaseOption() {
    let isProductSubscribeable = this.numberOfSellingPlans > 0;
    if (this.isSubscriber) {
      if (this.isInNextBox) {
        this.setPurchaseOption(this.requiresSellingPlan ? 'subscribe' : 'ship-now');
      } else if (isProductSubscribeable) {
        this.setPurchaseOption(this.defaultPurchaseOptionSubscribers);
      } else {
        this.setPurchaseOption(this.requiresSellingPlan ? 'subscribe' : 'add-to-next-box');
      }
    } else if (isProductSubscribeable) {
      this.setPurchaseOption(this.defaultPurchaseOption);
    } else {
      this.setPurchaseOption(this.requiresSellingPlan ? 'subscribe' : 'ship-now');
    }
  },

  handleFrequencyChange(event) {
    if (!event || !event.target) return;
    this.sellingPlanId = event.target.value;
    this.setPurchaseOption('subscribe');
  },

  setPurchaseOption(option) {
    this.purchaseOption = option;
    const addToNextBoxInput = this.formElement.querySelector('input[name="add_to_next_box"]');
    let sellingPlanInput = this.formElement.querySelector('input[name="selling_plan"]');
    if (option === 'subscribe') {
      const frequencySelector = this.$el.querySelector('#subscription-frequency-quickview');
      if (frequencySelector && frequencySelector.value) {
        this.sellingPlanId = String(frequencySelector.value);
      }
      if (this.sellingPlanId) {
        this.addToCartButtonText = window.dsc.addToCartText;
        if(this.isSubscriber) {
          this.addToCartButtonText = window.dsc.withSubscriptionState.subscribeButtonText;
        }
        else {
          this.addToCartButtonText = window.dsc.addToCartText;
        }
        if (sellingPlanInput) {
          sellingPlanInput.value = this.sellingPlanId;
        } else {
          sellingPlanInput = document.createElement('input');
          sellingPlanInput.type = 'hidden';
          sellingPlanInput.name = 'selling_plan';
          sellingPlanInput.value = this.sellingPlanId;
          this.formElement.appendChild(sellingPlanInput);
        }
        if (addToNextBoxInput) {
          addToNextBoxInput.value = 'false';
        }
      } else {
        this.addToCartButtonText = window.dsc.addToCartText;
        if (sellingPlanInput) sellingPlanInput.remove();
      }
      if (addToNextBoxInput) addToNextBoxInput.remove();

    } else if (option === 'add-to-next-box') {
      this.addToCartButtonText = window.dsc.addToNextBoxText;
      if (!addToNextBoxInput) {
        this.formElement.appendChild(this.createHiddenInput({ name: 'add_to_next_box', value: 'true' }));
      }
      if (sellingPlanInput) sellingPlanInput.remove();

    } else { // 'ship-now' or default
      this.submitButtonStateDisabled = !this.isAvailable;
      this.addToCartButtonText = window.dsc.addToCartText;
      if (addToNextBoxInput) addToNextBoxInput.remove();
      if (sellingPlanInput) sellingPlanInput.remove();
    }
  },

  createHiddenInput({ id, name, value }) {
    const hiddenInput = document.createElement('input');
    if (id) hiddenInput.id = id;
    hiddenInput.type = 'hidden';
    hiddenInput.name = name;
    hiddenInput.value = value;
    return hiddenInput;
  },

  resolveDefaultSellingPlanId(sellingPlanGroups) {
    const plans = sellingPlanGroups?.[0]?.selling_plans || [];
    if (!plans.length) return null;

    const defaultFrequency = Array.isArray(this.frequencySortOrder) && this.frequencySortOrder.length > 0
      ? String(this.frequencySortOrder[0]).trim()
      : null;

    if (defaultFrequency) {
      const matchedPlan = plans.find((plan) => {
        const planValue = plan?.options?.[0]?.value || '';
        const planFrequency = planValue === 'month' ? '1' : planValue.replace(' months', '').trim();
        return planFrequency === defaultFrequency;
      });
      if (matchedPlan) return String(matchedPlan.id);
    }

    return String(plans[0].id);
  },

  async fetchProductData() {
    if (!this.productHandle) return;
    try {
      this.isLoading = true;
      this.formElement = this.$el.closest('form');
      const response = await fetch(`/products/${this.productHandle}.js`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const product = await response.json();
      this.productData = product;
      this.productImage = product.featured_image;
      this.selectedVariant = product.variants.find((v) => v.available) || product.variants[0];
      this.selling_plan_groups = product.selling_plan_groups;
      this.sellingPlanId = this.resolveDefaultSellingPlanId(product.selling_plan_groups);
      this.numberOfSellingPlans = this.selling_plan_groups.reduce((count, group) => count + group.selling_plans.length, 0);
      
      this.getVariantPrice();
      this.getVariantComparePrice();
    } catch (error) {
      this.productData = { options: [], variants: [] };
    }
  },

  async addToNextBoxAsSubscription() {
    const orderId = this.upcomingOrders?.results?.[0]?.public_id;
    const productId = this.selectedVariant.id;
    const subscriptionFrequency = this.$el.querySelector('#subscription-frequency-quickview');
    const subscriptionFrequencyValue = window.dsc.ogFrequencyMap[subscriptionFrequency.value];

    if (!orderId || !productId || !subscriptionFrequencyValue) {
      return;
    }
    const response = await ogAddItemToNextBox({
      order: orderId,
      product: productId,
      quantity: 1,
    });

    await ogCreateFromItem({
      item: response.public_id,
      every: subscriptionFrequencyValue,
    }).then(() => {
      this.isInSubscription = true;
      this.isInNextBox = false;
      this.addToCartButtonText = window.dsc.addedToSubscription;

    }).finally(() => {
      this.invalidateProductsInNextOrderCache();

      const toastDetail = {
        type: 'success',
        product: this.productData,
        message: window.dsc.addedToSubscription,
      };
      // Check if this variant was already added to prevent duplicate events
      if (window.dsc.lastAddedVariantQuickview !== this.selectedVariant.id) {
        window.dsc.lastAddedVariantQuickview = this.selectedVariant.id;
        window.dsc.fireDlAddToNextBoxEvent(
          'subscribe',
          this.selectedVariant.id,
          this.selectedVariant.sku,
          this.quantity,
          this.sellingPlanId,
          this.productData
        );
      }
      this.closeWithTimeout(toastDetail);
    });
  },

  /* submission all flows */
  handleFormSubmit(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.submitButtonStateDisabled = true;
    const form = evt.target;
    const hasAddToNextBoxHiddenInput = form.querySelector('input[name="add_to_next_box"]');
    const submitButton = form.querySelector('button[type="submit"]');
    //subscriber add to subscription flow
    if (this.purchaseOption === 'subscribe' && this.isSubscriber) {
      this.addToNextBoxAsSubscription();
      return false;
    }
    //subscriber next box flow
    else if (hasAddToNextBoxHiddenInput && this.isSubscriber) {

      ogGetOgUpcomingOrders(this.customerId)
        .then((ogUpcomingOrders) => {
          if (!ogUpcomingOrders?.results?.length) {
            throw new Error('No upcoming orders found');
          }

          ogSortOGOrders(ogUpcomingOrders.results);
          const nextOrder = ogUpcomingOrders.results[0];
          window.dsc.nextboxdate = nextOrder.place;
          const orderId = nextOrder.public_id;
          const productId = form.querySelector('input[name="id"]').value;
          const productSku = this.selectedVariant?.sku || '';
          const productQuantity = form.querySelector('input[name="quantity"]').value;

          return ogAddItemToNextBox({
            order: orderId,
            product: productId,
            quantity: productQuantity,
          }).then(() => {
              this.isInSubscription = false;
              this.isInNextBox = true;
              this.addToCartButtonText = window.dsc.addedToCartText;
              this.invalidateProductsInNextOrderCache();
          }).catch(() => {
            // Error adding item to next box
          }).finally(() => {
            const toastDetail = {
              type: 'success',
              product: this.productData,
              message: window.dsc.addedToNextBox
            };
            // Check if this variant was already added to prevent duplicate events
            if (window.dsc.lastAddedVariantQuickview !== productId) {
              window.dsc.lastAddedVariantQuickview = productId;
              window.dsc.fireDlAddToNextBoxEvent(
                'add-one-time-to-next-box',
                productId,
                productSku,
                productQuantity,
                null,
                this.productData
              );
            }
            this.closeWithTimeout(toastDetail);
          });
        });
      return false;
    }
    else {
      //get it now flow
      const action = form.getAttribute('data-action');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);
      formData.set('id', this.selectedVariant.id);
      formData.set('quantity', this.quantity);
      if (this.purchaseOption !== 'subscribe') {
        formData.delete('selling_plan'); // Ensure selling_plan is not sent for one-time purchases
      }
      config.body = formData;

      fetch(action, { ...config, body: formData })
        .then(() => {
          const submitButton = form.querySelector('[type="submit"]');

          if (submitButton) {
            this.addToCartButtonText = window.dsc.addedToCartText;
          }
        })
        .catch(() => {
          if (submitButton) {
            this.addToCartButtonText = 'Error';
          }
        })
        .finally(() => {
          const toastDetail = {
            type: 'success',
            product: this.productData,
            message: window.dsc.addedToCartText,
          };
          this.closeWithTimeout(toastDetail, true);
        });
    }

  },
  closeWithTimeout(toastDetail) {
    if (toastDetail) {
      window.dispatchEvent(new CustomEvent('toast', {
        detail: toastDetail
      }));
    }
    if(this.isAccountOrOrderPage) {
      if (this.purchaseOption === 'subscribe') {
        window.dispatchEvent(new CustomEvent('refresh-customer-info'));
      }
      if (this.purchaseOption === 'add-to-next-box') {
        window.dispatchEvent(new CustomEvent('order-updated', { detail: { isDateLoading: false } }));
      }
    }
    if(this.productData?.variants?.length <= 1) {
      this.clickClose();
    }
  },

});
